import { useParams, Navigate } from "react-router-dom";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { SizeSelector } from "@/components/SizeSelector";
import { ColourSwatches, CustomColourPrompt } from "@/components/ColourSwatches";
import { SeeInPerson } from "@/components/SeeInPerson";
import { PurchaseSteps } from "@/components/PurchaseSteps";
import { img } from "@/lib/site";
import { FLOORING } from "@/lib/timber";

export default function FlooringDetail() {
  const { sub } = useParams();
  const data = FLOORING[sub];
  if (!data) return <Navigate to="/collections/timber/flooring" replace />;

  return (
    <div data-testid="flooring-detail">
      <Breadcrumbs
        items={[
          { label: "Our Collection", to: "/collection" },
          { label: "Timber Collection", to: "/collections/timber" },
          { label: "Timber Flooring", to: "/collections/timber/flooring" },
          { label: data.name },
        ]}
      />

      <section className="edge pt-8 pb-12 md:pt-12" data-testid="flooring-detail-head">
        <span className="eyebrow">Timber Flooring</span>
        <h1 className="mt-5 text-4xl font-light leading-[1.02] tracking-editorial md:text-6xl">
          {data.name}
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground md:text-lg">
          {data.intro}
        </p>
      </section>

      <section className="edge pb-16 md:pb-24">
        <div className="overflow-hidden bg-secondary/40">
          <img src={img(data.hero, 2400)} alt={data.name} className="aspect-[16/9] w-full object-cover" />
        </div>
      </section>

      {/* Specs + colours */}
      <section className="edge pb-20 md:pb-28">
        <div className="grid grid-cols-1 gap-x-10 gap-y-14 md:grid-cols-12">
          <div className="md:col-span-5">
            <SizeSelector sizes={data.sizes} />
          </div>
          <div className="md:col-span-6 md:col-start-7">
            <span className="eyebrow">Colour Selection</span>
            <div className="mt-5">
              <ColourSwatches colours={data.colours} columns="grid-cols-3 sm:grid-cols-5" />
            </div>
            <CustomColourPrompt />
          </div>
        </div>
      </section>

      <SeeInPerson />
      <PurchaseSteps />
    </div>
  );
}
